module.exports = __webpack_public_path__ + "img/codrej-hanging.63316e91.svg";